/*
 * Promotions: every discount that is not the long-hire one.
 *
 * Whoever creates a promo pays for it. A Zuruflex promo leaves the partner's
 * earnings on the full price; a partner promo leaves Zuruflex's commission on
 * it. A promo never stacks with the long-hire discount — the larger of the
 * two, by amount, is the single discount line on the quote.
 *
 * These arrays mirror the Prisma enums of the same names.
 */
export const PROMOTION_FUNDERS = ['ZURUFLEX', 'PARTNER'];
/** CODE is typed at checkout; AUTOMATIC applies itself to any booking that qualifies. */
export const PROMOTION_TRIGGERS = ['CODE', 'AUTOMATIC'];
/** FIRST_HIRE is a customer with no earlier hire; ASSIGNED is a named list. */
export const PROMOTION_AUDIENCES = ['EVERYONE', 'FIRST_HIRE', 'ASSIGNED'];
export const PROMOTION_DISCOUNT_TYPES = ['PERCENT', 'FIXED'];
/** Deleting a promo archives it: the bookings that used it still point at it. */
export const PROMOTION_STATUSES = ['ACTIVE', 'PAUSED', 'ARCHIVED'];
export const PROMOTION_SOURCES = ['MANUAL', 'REFERRAL_REWARD', 'REFERRAL_WELCOME'];
export const PROMOTION_REDEMPTION_STATUSES = ['RESERVED', 'CONFIRMED', 'RELEASED'];
export const REFERRAL_STATUSES = ['PENDING', 'QUALIFIED', 'REWARDED', 'VOID'];
/**
 * Why a promo was not applied, as a key under `common:promo.rejected`.
 *
 * `beatenByLongHire` is not a failure of the promo: the booking qualified,
 * but the long-hire discount was worth more, and only one discount applies.
 */
export const PROMO_REJECTIONS = [
    /** Neither a promo code nor anybody's referral code. */
    'unknownCode',
    'expired',
    'notStarted',
    'exhausted',
    'perCustomerLimit',
    'notEligibleVehicle',
    'minDays',
    'minSubtotal',
    'firstHireOnly',
    'notAssigned',
    'ownReferral',
    'beatenByLongHire',
];
